import {
  CLEAR_SINGLE_CLIENT_REPORT_PDF,
  EXPORT_SINGLE_CLIENT_REPORT_PDF,
} from "../../types";

import createAsyncActions from "../../../../utilities/createAsyncActions";
import { createAction } from "redux-actions";

export const {
  exportSingleClientReportPdf,
  exportSingleClientReportPdfPending,
  exportSingleClientReportPdfFulfilled,
  exportSingleClientReportPdfRejected,
} = createAsyncActions(
  EXPORT_SINGLE_CLIENT_REPORT_PDF,
  "exportSingleClientReportPdf"
);

export const clearSingleClientReportPdf = createAction(
  CLEAR_SINGLE_CLIENT_REPORT_PDF
);



// WEBPACK FOOTER //
// ./src/features/reports/actions/single-client/exportSingleClientReportPdfActions.js